import { Box, Stack, Typography } from "@mui/material";
import { Divider } from "../base/components/Divider/Divider";
import { UserType } from "@/global/store/data/types";
import { useTranslation } from "react-i18next";

export function HamburgerMenuUser(props: { user: UserType }) {
  const { t } = useTranslation();
  return (
    <Box>
      <Stack paddingX={2} paddingY={1}>
        <Typography fontSize={"18px"} fontWeight={700}>
          {props.user.firstName.slice(0, 1)}. {props.user.lastName}
        </Typography>
        <Typography fontSize={"12px"}>{props.user.email}</Typography>
        <Typography fontSize={"12px"}>
          {t("accountDetails.accountIdLabel") || "Account"}:{" "}
          {props.user.accountId}
        </Typography>
        <Typography fontSize={"12px"}>
          {t("accountDetails.phoneNumberLabel") || "Phone"}:{" "}
          {props.user.phoneNumber}
        </Typography>
      </Stack>
      <Divider />
    </Box>
  );
}
